<template>
	<div class="row contentblock">
		<div class="columns column6 col-image">
			<picture>
				<source :srcset="imageWebp" type="image/webp" />
				<source :srcset="image" />
				<img :src="image" :alt="imageAlt" loading="lazy" />
			</picture>
		</div>
		<div class="columns column6 col-content">
			<div class="contentblock-content">
				<h3>{{ header }}</h3>
				<div v-parse-links v-html="content" />
			</div>
		</div>
	</div>
</template>

<script setup>
defineProps({
	image: { type: String, default: '' },
	imageWebp: { type: String, default: '' },
	imageAlt: { type: String, default: '' },
	header: { type: String, default: '' },
	content: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.contentblock {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	padding: 0;
	margin: 40px auto;
	position: relative;

	&:nth-child(odd) {
		flex-direction: row-reverse;

		.col-image {
			left: 0;
			right: auto;
		}

		.col-content {
			padding: 25px 0 25px 10%;
		}
	}

	.columns:first-child {
		padding: 0;
	}

	img {
		object-fit: cover;
		width: 100%;
		height: 100%;
	}

	.col-content {
		padding: 40px 8% 40px 0;
		background: var(--secondary-background-color);
		position: relative;
		z-index: 1;
		width: 53%;
	}

	.col-image {
		position: absolute;
		top: 50px;
		right: 0;
		bottom: 50px;
		width: 57%;
		z-index: 2;
	}

	.contentblock-content {
		padding: 75px;
		min-height: 420px;
	}
}

@media (max-width: 1080px) {
	.contentblock {
		.col-image {
			width: 100%;
			position: relative;
			inset: auto;
		}

		.col-content {
			padding: 0 !important;
			width: 100%;
			margin: 0 auto;
		}

		.contentblock-content {
			padding: 50px;
			min-height: auto;
		}
	}
}

@media (max-width: 580px) {
	.contentblock {
		margin-bottom: 25px;

		.contentblock-content {
			padding: 35px;
		}
	}
}
</style>
